<svelte:options
  customElement={{
    tag: "oc-block-v2",

    extend: window.__components.extend(),
    props: {
      elevationLevel: { type: "String", attribute: "elevation-level" },
      padding: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./BlockV2.types.js";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let { elevationLevel = "canvas", padding = "default" }: Props = $props();
</script>

<div class={`block block-elevation--${elevationLevel} block-padding--${padding}`}>
  <slot />
</div>

<DefaultStyles display="block" />

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";

  :global {
    :host {
      --oc-block-background-color: initial;
      --background-color: initial;
      --custom-spacing-y: #{tokens.$oc-component-block-default-spacing-y};
      --custom-spacing-x: #{tokens.$oc-component-block-default-spacing-x};
    }

    .block {
      padding: var(--custom-spacing-y) var(--custom-spacing-x);

      &-elevation--canvas {
        background-color: var(
          --background-color,
          var(--oc-block-background-color, #{tokens.$oc-component-block-background-color-default})
        );
        &.block-padding--no-padding {
          padding: 0;
        }
        &.block-padding--full-bleed {
          padding: tokens.$oc-component-block-default-spacing-y 0;
        }
      }

      &-elevation--stacked {
        background-color: var(--background-color, var(--oc-block-background-color, transparent));
        border-radius: tokens.$oc-component-block-stacked-border-radius;
        outline: 1px solid
          var(
            --background-color,
            var(--oc-block-background-color, #{tokens.$oc-component-block-stacked-border-color})
          );
        padding: var(--custom-spacing-y, #{tokens.$oc-component-block-stacked-default-spacing-x})
          var(--custom-spacing-x, #{tokens.$oc-component-block-stacked-default-spacing-y});

        &.block-padding--no-padding {
          padding: 0;
        }
        &.block-padding--full-bleed {
          padding: tokens.$oc-component-block-stacked-default-spacing-y 0;
        }
      }
    }
  }
</style>
